import { useCallback } from "react";
import AsyncAutocomplete from "./AsyncAutocomplete";
import { searchCities } from "../../api/CityService";

/**
 * Searchable, infinite-scrolling city picker, scoped to the selected zone.
 * Disabled until a zone is chosen; resets its options when the zone changes.
 */
export default function CitySelect({
  zoneId = "",
  label = "City",
  disabled = false,
  ...props
}) {
  const fetchPage = useCallback(
    async (page, search) => {
      const res = await searchCities({ page, search, perPage: 50, zoneId });
      const paginator = res?.data ?? {};
      return {
        items: Array.isArray(paginator.data) ? paginator.data : [],
        hasMore: (paginator.current_page || 1) < (paginator.last_page || 1),
      };
    },
    [zoneId],
  );

  return (
    <AsyncAutocomplete
      label={label}
      fetchPage={fetchPage}
      refreshKey={zoneId || null}
      disabled={disabled || !zoneId}
      {...props}
    />
  );
}
